import {
  Button,
  ExpandIcon,
  Flex,
  IconButton,
  ShrinkIcon,
  SwapArrowsIcon,
  SyncAltIcon,
  Text,
  TradingViewIcon,
  LineGraphIcon,
  BarChartIcon,
  useMatchBreakpointsContext,
} from '@pancakeswap/uikit'
import { useState, useCallback, useEffect } from 'react'
import { CurrencyLogo, DoubleCurrencyLogo } from 'components/Logo'
import { TradingViewLabel } from 'components/TradingView'
import { useTranslation } from 'contexts/Localization'
import { ChartViewMode } from 'state/user/actions'
import { useExchangeChartViewManager } from 'state/user/hooks'
import styled from 'styled-components'
import { PairDataTimeWindowEnum } from 'state/swap/types'
import { useFetchPairId, usePairHasEnoughLiquidity } from 'state/swap/hooks'
import { usePoolTransactions } from 'state/info/hooks'
import { StyledDataTable } from './styleds'
import SwapDataTable from './SwapDataTable'

const ChartButton = styled(Button)`
  border: 2px solid transparent;
  ${({ $active, theme }) => $active && `border: 2px solid ${theme.colors.primary}4b`};
  padding: 4px 10px;
  border-radius: 10px;
  &:hover{
    background: ${({ theme }) => theme.colors.tertiary }
  }
`

const SwapData = ({
  inputCurrency,
  outputCurrency,
  onSwitchTokens,
  isDark,
  isChartExpanded,
  setIsChartExpanded,
  isMobile,
  isFullWidthContainer,
  token0Address,
  token1Address,
  currentSwapPrice,
}) => {
  // const { isDesktop } = useMatchBreakpointsContext()
  // const toggleExpanded = () => setIsChartExpanded((currentIsExpanded) => !currentIsExpanded)
  // const [chartView, setChartView] = useExchangeChartViewManager()
  const { t } = useTranslation()
  const [timeWindow, setTimeWindow] = useState<PairDataTimeWindowEnum>(0)

  const { pairId } = useFetchPairId({ token0Address, token1Address })

  const hasEnoughLiquidity = usePairHasEnoughLiquidity(pairId, timeWindow)
  const transactions = usePoolTransactions(pairId)

  return (
    <StyledDataTable
      $isDark={isDark}
      $isExpanded={isChartExpanded}
      $isFullWidthContainer={isFullWidthContainer}
      mb="40px"
    >
      <Flex justifyContent="space-between">
        {hasEnoughLiquidity ? (
          <SwapDataTable
            transactions={transactions}
            pairId={pairId}
            inputCurrency={inputCurrency}
            outputCurrency={outputCurrency}
          />
        ) : (
          <Text style={{ margin: '15px auto 0', opacity: '0.5' }} color="textSubtle">
            Multi-hop / failed to load trading data.
          </Text>
        )}
      </Flex>
    </StyledDataTable>
  )
}

export default SwapData
